import React, { useState } from "react";
import { jurisdictions } from "../../data/intelligence";
import { formatUpdated } from "../../utils/intelligence";
import { SectionLabel } from "../SectionLabel";
type Region = "us" | "intl";
type JurisdictionIndexProps = {
  onSelect: (name: string) => void;
};
const tabs: {
  id: Region;
  label: string;
}[] = [{
  id: "us",
  label: "United States"
}, {
  id: "intl",
  label: "International"
}];
export function JurisdictionIndex({
  onSelect
}: JurisdictionIndexProps) {
  const [region, setRegion] = useState<Region>("us");
  const visible = jurisdictions.filter(j => j.region === region);
  return <section aria-labelledby="jurisdictions-title" className="border-t border-stone" data-id="element-360" data-mp="1rorlskmkv7cp">
      <div className="shell py-24 md:py-32" data-id="element-361" data-mp="1wnupa0mwt5ik">
        <div className="grid grid-cols-12 gap-x-6 gap-y-8 pb-12" data-id="element-362" data-mp="1wqqorteeo294">
          <div className="col-span-12 lg:col-span-5" data-id="element-363" data-mp="g9l41fdyrwvy">
            <SectionLabel data-id="element-364" data-mp="l9h4x5rd787a">Jurisdictions</SectionLabel>
            <h2 id="jurisdictions-title" className="mt-6 font-display text-[clamp(2.25rem,4.2vw,3.5rem)] leading-[1.06] text-navy" data-id="element-365" data-mp="lb21t215j38b">
              Every place you pay people.
            </h2>
          </div>
          <div className="col-span-12 flex flex-col justify-end gap-6 lg:col-span-6 lg:col-start-7" data-id="element-366" data-mp="3n3nlnxu3gcc">
            <p className="max-w-md leading-relaxed text-charcoal/75" data-id="element-367" data-mp="ijuroaigdg8a">
              Registration, withholding, pay frequency, final pay, and leave — by state and by country, reviewed on a
              set schedule.
            </p>
            <div role="group" aria-label="Region" className="flex gap-6" data-id="element-368" data-mp="mk4ujeay7qix">
              {tabs.map(t => <button key={t.id} type="button" aria-pressed={region === t.id} onClick={() => setRegion(t.id)} className={`whitespace-nowrap border-b py-1 text-[13px] font-semibold uppercase tracking-[0.14em] transition-colors duration-150 ${region === t.id ? "border-oxblood text-oxblood" : "border-transparent text-charcoal/60 hover:text-oxblood"}`} data-id="element-369" data-mp="118ri23aqbol8">
                  {t.label}
                </button>)}
            </div>
          </div>
        </div>

        <ul className="grid grid-cols-2 border-l border-t border-stone border-t-navy sm:grid-cols-3 lg:grid-cols-6" data-id="element-370" data-mp="1n98ary2sp4nq">
          {visible.map(j => <li key={j.code} className="border-b border-r border-stone" data-id="element-371" data-mp="1s2b5wan80m61">
              <button type="button" onClick={() => onSelect(j.name)} className="group block h-full w-full p-5 text-left transition-colors duration-150 hover:bg-stone/30" data-id="element-372" data-mp="1w1aa1t14oewf">
                <span className="block font-display text-4xl leading-none text-navy transition-colors duration-150 group-hover:text-oxblood" data-id="element-373" data-mp="25y549zqdbt4w">
                  {j.code}
                </span>
                <span className="mt-4 block text-sm font-medium text-charcoal" data-id="element-374" data-mp="bobb1e38fmpn">{j.name}</span>
                <span className="mt-1 block text-[11px] tabular-nums text-charcoal/55" data-id="element-375" data-mp="gn5u8h543daa">
                  {j.guides} guides · {formatUpdated(j.updated, "MMM yyyy")}
                </span>
              </button>
            </li>)}
        </ul>
      </div>
    </section>;
}